(function () {
  'use strict';

  const button = document.querySelector('#convx-klaviyo-button');
  const wrapper = button.closest('.convx-klaviyo-button--wrapper');

  if (isReturningUser()) {
    return;
  }

  button.addEventListener('click', onClick);
  wrapper.removeAttribute('hidden');

  function onClick() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'S4ShBG']);
  }

  function isReturningUser() {
    const now = new Date();
    let firstVisit = localStorage.getItem('firstVisit');
    
    if (!firstVisit) {
      localStorage.setItem('firstVisit', now);
      return false;
    }

    firstVisit = new Date(firstVisit);
    
    const elapse = now - firstVisit;

    // 30 minutes
    return elapse > 30 * 60 * 1000;
  }
})();
